import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import { NavItemEnum, SegmentedNavItems } from '../../constants/routing/NavItems';
import { usePageParams } from '../../hooks/usePageParams';
const MobileDropdownNavLabel = styled(UIFormControl).withConfig({
  displayName: "MobileDropdownNav__MobileDropdownNavLabel",
  componentId: "sc-7iy5u3-0"
})(["width:94%;margin:0 auto;"]);

const MobileDropdownNav = ({
  selectedNavItem
}) => {
  const history = useHistory();
  const {
    tab
  } = usePageParams();
  const [currNavItem, selectCurrNavItem] = useState(selectedNavItem);
  const navItemOptions = Object.values(SegmentedNavItems).flat().map(navItem => ({
    text: `pricingPage.pages.products.tabs.${navItem}.tabTitle`,
    value: navItem
  }));

  const hasTabs = navItem => {
    return NavItemEnum.BUNDLE !== navItem && NavItemEnum.FREE !== navItem && NavItemEnum.COMMERCE !== navItem;
  };

  const handleChange = evt => {
    evt.preventDefault();
    const newNavItem = evt.currentTarget.value;
    const toValue = `/${newNavItem}${tab && hasTabs(newNavItem) ? `/${tab}` : ''}`;
    selectCurrNavItem(newNavItem);
    history.push(toValue);
  };

  const OptionComponent = (_ref) => {
    let {
      option
    } = _ref,
        rest = _objectWithoutPropertiesLoose(_ref, ["option", "__children"]);

    return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: option.text
      })
    }));
  };

  return /*#__PURE__*/_jsx(MobileDropdownNavLabel, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.tabs.pricingAndPlans"
    }),
    children: /*#__PURE__*/_jsx(UISelect, {
      searchable: false,
      itemComponent: OptionComponent,
      options: navItemOptions,
      onChange: handleChange,
      value: currNavItem
    })
  });
};

export default MobileDropdownNav;